const TX_MSG = {
  MsgTransfer: '/ibc.applications.transfer.v1.MsgTransfer',
  MsgLiquidStake: '/stride.stakeibc.MsgLiquidStake',
  MsgRedeemStake: '/stride.stakeibc.MsgRedeemStake',
  MsgClaimUndelegatedTokens: '/stride.stakeibc.MsgClaimUndelegatedTokens'
}

export { TX_MSG }
